/* Regnum wishlist-wire: keeps our brand-styled product-page heart in sync
   with Wishlist Hero's saved state. Header click + count are handled by WLH
   itself via the `<a href="#hero-wishlist" class="wishlist-hero-header-show-count-only">`
   pattern in header.liquid.

   Detection: a hybrid that watches WLH's events AND its hidden product-page
   button. Events give instant feedback; the button mutation observer covers
   the initial load when WLH fetches items from the server.
*/
(function () {
  'use strict';

  function getProductIdAndVariantId() {
    var ids = { productId: null, variantId: null };
    var pdpJson = document.getElementById('WH-ProductJson-product-template');
    if (pdpJson) {
      try {
        var p = JSON.parse(pdpJson.textContent);
        if (p) {
          if (p.id) ids.productId = String(p.id);
          if (p.variants && p.variants.length) ids.variantId = String(p.variants[0].id);
        }
      } catch (e) {}
    }
    // Also grab variant from URL ?variant= if present (more accurate than first variant)
    try {
      var url = new URL(window.location.href);
      var v = url.searchParams.get('variant');
      if (v) ids.variantId = String(v);
    } catch (e) {}
    return ids;
  }

  function findWlhButton() {
    return document.querySelector(
      '.wishlist-hero-product-app-block button, ' +
      '#wishlisthero-product-page-button-container button, ' +
      '[id^="wishlisthero-product-page"] button'
    );
  }

  function isSavedFromButton(btn) {
    if (!btn) return false;
    var text = (btn.textContent || '').trim();
    if (/added/i.test(text)) return true;
    // "Remove" appears in the saved-state button label too (when EnableRemoveFromWishlistAfterAdd is on)
    if (/remove/i.test(text)) return true;
    if (btn.getAttribute('aria-pressed') === 'true') return true;
    if (btn.className && /\b(added|saved|wlh-added|in-wishlist|active)\b/i.test(btn.className)) return true;
    return false;
  }

  function setSaved(saved) {
    var wrap = document.querySelector('.regnum-icon-actions .wishlist-productpage');
    if (!wrap) return;
    if (saved) wrap.classList.add('is-saved');
    else wrap.classList.remove('is-saved');
  }

  function syncFromButton() {
    var btn = findWlhButton();
    if (!btn) return;
    setSaved(isSavedFromButton(btn));
  }

  function watchWlhButton() {
    var btn = findWlhButton();
    if (!btn) return false;
    if (btn.dataset.regnumWatched === 'true') return true;
    var mo = new MutationObserver(function () {
      syncFromButton();
    });
    mo.observe(btn, {
      attributes: true,
      attributeFilter: ['class', 'aria-pressed', 'data-state'],
      childList: true,
      subtree: true,
      characterData: true,
    });
    btn.dataset.regnumWatched = 'true';
    syncFromButton();
    return true;
  }

  function startWatching() {
    if (watchWlhButton()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (watchWlhButton() || tries > 60) clearInterval(timer);
    }, 200);
  }

  // Event handlers: WLH fires these as the customer adds/removes items
  function onAddItem(e) {
    var ids = getProductIdAndVariantId();
    var info = e && e.detail && e.detail.productInfo;
    if (!info) {
      setSaved(true); // assume the most recent click was for current product
      return;
    }
    var addedId = info.id || info.productId || info.product_id;
    var addedVariant = info.variantId || info.variant_id;
    if (addedId && ids.productId && String(addedId) === ids.productId) setSaved(true);
    else if (addedVariant && ids.variantId && String(addedVariant) === ids.variantId) setSaved(true);
    else syncFromButton();
  }

  function onDeleteItem(e) {
    var ids = getProductIdAndVariantId();
    var deletedVariant = e && e.detail && (e.detail.variantId || e.detail.ProductVariantId);
    if (deletedVariant && ids.variantId && String(deletedVariant) === ids.variantId) setSaved(false);
    else syncFromButton();
  }

  function onItemsFromServer(e) {
    var ids = getProductIdAndVariantId();
    var items = e && e.detail && (e.detail.items || e.detail);
    if (!items || !items.length) { setSaved(false); return; }
    var saved = items.some(function (it) {
      var v = it.variantId || it.ProductVariantId || it.variant_id;
      var p = it.id || it.productId || it.product_id;
      return (v && ids.variantId && String(v) === ids.variantId)
          || (p && ids.productId && String(p) === ids.productId);
    });
    setSaved(saved);
  }

  function init() {
    startWatching();
    // Multiple delayed re-syncs catch the initial server-loaded items
    [400, 1200, 2500, 5000].forEach(function (ms) {
      setTimeout(syncFromButton, ms);
    });
    rememberCurrentPage();
    maybeAutoOpenFromUrl();
  }

  /* On every storefront page, remember the URL so the Customer Accounts
     "Wishlist" menu link can bounce the customer back to the page they
     were last on (instead of always dumping them on the homepage). */
  function rememberCurrentPage() {
    try {
      var p = window.location.pathname;
      // Skip routes the customer wouldn't want to be bounced back into
      if (/^\/(cart|checkout|account|tools|apps|password)(\/|$)/i.test(p)) return;
      if (window.location.search.indexOf('open-wishlist') !== -1) return;
      var url = p + window.location.search;
      document.cookie = 'regnum_last_url=' + encodeURIComponent(url) +
        '; path=/; max-age=86400; SameSite=Lax';
    } catch (e) {}
  }

  function readLastUrlCookie() {
    var m = document.cookie.match(/(?:^|;\s*)regnum_last_url=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  /* Customer Accounts "Wishlist" menu link sends users here with
     ?open-wishlist=1. If a remembered URL exists and isn't the page we're
     currently on, redirect there carrying the param along. Otherwise
     trigger WLH and clean the URL so refresh doesn't re-open. */
  function maybeAutoOpenFromUrl() {
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.get('open-wishlist') !== '1') return;

      var here = u.pathname + u.search.replace(/[?&]open-wishlist=1/, '').replace(/^&/, '?');
      if (here.endsWith('?')) here = here.slice(0, -1);
      var last = readLastUrlCookie();

      if (last && last !== here && last !== u.pathname) {
        var sep = last.indexOf('?') === -1 ? '?' : '&';
        window.location.replace(last + sep + 'open-wishlist=1');
        return;
      }

      var clean = u.pathname + (u.search.replace(/[?&]open-wishlist=1/, '').replace(/^&/, '?')) + u.hash;
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, document.title, clean);
      }

      var attempts = 0;
      var timer = setInterval(function () {
        attempts++;
        var trigger = document.querySelector(
          'a.wishlist-hero-header-show-count-only, ' +
          '.wishlist-hero-floating, ' +
          '[id^="wishlisthero-launch-point"], ' +
          'a[href="#hero-wishlist"]'
        );
        if (trigger) {
          clearInterval(timer);
          trigger.click();
        } else if (attempts > 40) {
          clearInterval(timer);
        }
      }, 200);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 100); });
  } else {
    setTimeout(init, 100);
  }

  document.addEventListener('wishlist-hero-wishlist-add-item', onAddItem);
  document.addEventListener('wishlist-hero-wishlist-delete-item', onDeleteItem);
  document.addEventListener('wishlist-hero-wishlist-items-from-server', onItemsFromServer);
  document.addEventListener('wishlist-hero-wishlist-items', onItemsFromServer);
  document.addEventListener('wishlist-hero-wishlist-updated', syncFromButton);

  /* Inline-style fallback: force brand-purple on cart + account badges in
     case Xtra's CSS load order or specificity defeats our overrides. */
  function paintBadges() {
    var color = '#1A1424';
    var cartCss = 'background:' + color + ' !important;' +
                  'background-color:' + color + ' !important;' +
                  'color:#ffffff !important;' +
                  'border:2px solid #ffffff !important;' +
                  'border-radius:50% !important;' +
                  'box-shadow:0 1px 3px rgba(26,20,36,.2) !important;';
    var acctCss = cartCss;
    var cart = document.querySelector('#nav-user li.cart #cart-count');
    if (cart && cart.textContent.trim() !== '0' && cart.textContent.trim() !== '') {
      cart.style.cssText = cartCss;
    }
    var acct = document.querySelector('#nav-user li .icon-user > span');
    if (acct) {
      acct.style.cssText = acctCss;
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(paintBadges, 200); });
  } else {
    setTimeout(paintBadges, 200);
  }
  [600, 1500, 3000].forEach(function (ms) { setTimeout(paintBadges, ms); });
})();
